import { IonCol } from "@ionic/react";
import { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useIntl } from "react-intl";

import DateInput from "@components/fields/DateInput";
import Select from "@components/fields/Select";
import { TimePeriodEnum } from "@typing/Enums";

type PartialFormData = {
  endDate?: string | null;
  startDate?: string | null;
  timePeriod?: TimePeriodEnum | null;
};

type Props = {
  form: UseFormReturn<PartialFormData, any>;
};

const TimePeriodField = ({ form }: Props) => {
  const intl = useIntl();

  const timePeriod = form.watch("timePeriod");

  const timePeriodOptions = useMemo(() => {
    const options = [
      TimePeriodEnum.SEVEN_DAYS,
      TimePeriodEnum.THIRTY_DAYS,
      TimePeriodEnum.SIXTY_DAYS,
      TimePeriodEnum.NINETY_DAYS,
      TimePeriodEnum.ALL_TIME,
      TimePeriodEnum.CUSTOM
    ];

    return options.map(option => ({
      label: intl.formatMessage({ id: `forms.timePeriod.periodOptions.${option}` }),
      value: option
    }));
  }, [intl]);

  return (
    <>
      <IonCol>
        <Select<PartialFormData>
          control={form.control}
          error={form.formState.errors.timePeriod}
          label={intl.formatMessage({ id: "forms.timePeriod.timePeriodLabel" })}
          name="timePeriod"
          options={timePeriodOptions}
        />
      </IonCol>
      <IonCol className={timePeriod === TimePeriodEnum.CUSTOM ? "" : "ion-hide"}>
        <DateInput<PartialFormData>
          actions={[
            {
              ariaLabelKey: "accessibility.ariaLabels.delete",
              icon: "times",
              onClick: () => form.setValue("startDate", "", { shouldTouch: true })
            }
          ]}
          control={form.control}
          error={form.formState.errors.startDate}
          label={intl.formatMessage({ id: "forms.timePeriod.startTimeLabel" })}
          register={form.register("startDate")}
        />
      </IonCol>
      <IonCol className={timePeriod === TimePeriodEnum.CUSTOM ? "" : "ion-hide"}>
        <DateInput<PartialFormData>
          actions={[
            {
              ariaLabelKey: "accessibility.ariaLabels.delete",
              icon: "times",
              onClick: () => form.setValue("endDate", "", { shouldTouch: true })
            }
          ]}
          control={form.control}
          error={form.formState.errors.endDate}
          label={intl.formatMessage({ id: "forms.timePeriod.endTimeLabel" })}
          register={form.register("endDate")}
        />
      </IonCol>
    </>
  );
};

export default TimePeriodField;
